const defaults = { 
    method: "GET", // *GET, POST, PUT, DELETE, etc.   
    cache: "default", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {},
    body: null,
    responseType: "", // text, json, document, arraybuffer, blob
    timeout: 0,
    onupload: null,
    ondownload: null
}

export default defaults